import React, {useEffect, useState} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import MeChildHeader from '../../components/me-child-header'
import { action_delete_credit_card, action_get_credit_cards } from '../../../../../store/actions/pages/customer'
import { useStore, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { useQuery } from '../../../../hooks/common'
import MeListEmpty from '../../components/list-empty'
import { useMemo } from 'react'
import { Iconfont } from '../../../../components/icon/iconfont'
import NormalConfigConfirm from '../../../../../client/components/alert/config-confirm'
import { IMAGE_GEEKO_LTD } from '../../../../../constants'
import MeLoading from '../../components/loading'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'

const Card = props => {
    useStyles(classes)
    const { data, deleteCard, Intl } = props || {}
    const { style:cardStyle, quickpayRecord } = data || {}
    const { id } = quickpayRecord || {}

    const cardInfo = useMemo(() => {
        let bgColor, fontColor, cardName;
        let cardImg = `${IMAGE_GEEKO_LTD}/chicme/Credit+Card.png`
        if(cardStyle){
            bgColor = cardStyle?.color || '#fff'
            fontColor = cardStyle?.fontColor || '#222'
            cardName = cardStyle?.name && cardStyle?.name != 'other' ? cardStyle?.name: ''
            cardImg = cardStyle?.imageURL || cardImg
        } else {
            bgColor = '#fff'
            fontColor = '#222'
            cardName = ''
        }
        return {bgColor, fontColor, cardName, cardImg}
    }, [cardStyle])

    const beforeDeleteCard = () => {
        NormalConfigConfirm({
            boxStyle:{
                padding:"25px",
            },
            message:{
                text: Intl.formatMessage({id: 'sure_delete_card'})+'?',
                style:{
                    fontFamily: 'Roboto',
                    fontSize: '14px',
                    lineHeight: 'normal',
                    color:'#222222',
                    textAlign: 'center'
                },
                html:false
            },
            btn1:{
                text: Intl.formatMessage({id: 'yes'}),
                style: {},
                clickHandle:() =>{
                    let cardId = id
                    let payMethod = quickpayRecord?.payMethod
                    if(payMethod == '19'){
                        cardId = quickpayRecord?.quickpayId
                    }
                    deleteCard(cardId, payMethod)
                }
            },
            btn2:{
                text: Intl.formatMessage({id: 'no'}),
                style: {},
                clickHandle:() =>{}
            }
        })
    }

    return <div className={classes.Card} style={{backgroundColor: cardInfo?.bgColor}}>
        <div className={classes.CardImg}>
            <img src={cardInfo?.cardImg}/>
        </div>
        <div className={classes.CardInfo} style={{color: cardInfo?.fontColor}}>
            <span>{cardInfo?.cardName}</span>
            <span>{quickpayRecord?.cardNumber}</span>
        </div>
        <div className={classes.CardDelete}  onClick={() => beforeDeleteCard()}>
            <Iconfont className={classes.DeleteIcon}>&#xe629;</Iconfont>
        </div>
    </div>
}

const CardsList = props => {
    useStyles(classes)

    const {list} = props || {}

    return <div className={classes.CardsList}>
        {
            list?.map((item, index) => {
                return <Card {...props} key={index} data={item}/>
            })
        }
    </div>
}

const CreditCards = props => {
    useStyles(classes)

    const [loading, setLoading] = useState(true)
    const pageCustomer = useSelector(state => state.pageCustomer);
    const {creditCards} = pageCustomer || {}
    const dispatch = useDispatch()
    const Intl = useIntl()

    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const history = useHistory()

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            if(!creditCards){
                await CreditCards.fetchData(store, params, query)
            }
		}
    }, [])

    useEffect(() => {
        if(creditCards){
            setLoading(false)
        } else {
            setTimeout(() => {
                setLoading(false)
            }, 5000)
        }
    },[creditCards])

    const onBack = () => {
        history.go(-1)
    }

    const deleteCard = (cardId, payMethod) => {
        setLoading(true)
        dispatch(action_delete_credit_card(cardId, payMethod))
        .then(res => {
            setLoading(false)
        })
    }

    return <div classes={classes.CreditCardPage}>
        <MeChildHeader name={Intl.formatMessage({id: 'my_payment_options'})} onBack={() => onBack()}/>

        {
            creditCards?.length > 0 ?
            <CardsList list={creditCards} deleteCard={(item) => deleteCard(item)} Intl={Intl}/>:
            <MeListEmpty/>
        }

        <MeLoading loading={loading} />
    </div>
}

CreditCards.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_get_credit_cards(headers))
}

export default CreditCards